import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=1af685cd&scoped=true&"
import script from "./Documentos.vue?vue&type=script&lang=ts&"
export * from "./Documentos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af685cd",
  null
  
)

export default component.exports